import CtaLayout from '@components/CtaLayout';
import Divider from '@components/Divider';
import Header from '@components/Header';
import PrepaidCardAmount from '@components/prepaid/PrepaidCardAmount';
import PrepaidCardChargeMethod from '@components/prepaid/PrepaidCardChargeMethod';
import PrepaidCardInfo from '@components/prepaid/PrepaidCardInfo';
import PrepaidCardNotes from '@components/prepaid/PrepaidCardNotes';
import PrepaidProvider from '@components/prepaid/PrepaidProvider';
import { AppScreen } from '@stackflow/plugin-basic-ui';
import { ActivityComponentType } from '@stackflow/react';
import { useTranslation } from 'react-i18next';

import PrepaidCardChargeFooter from './components/PrepaidCardChargeFooter';

interface Params {
    prepaidCardId: string;
    amount?: number;
}

const PrepaidCardChargeActivity: ActivityComponentType<Params> = ({ params }:{params: Params}) => {
    const { t } = useTranslation('prepaidCard');
    const { prepaidCardId, amount } = params;
    return (
        <AppScreen>
            <PrepaidProvider>
                <CtaLayout header={<Header title={t('charge.title')} />}
                    footer={<PrepaidCardChargeFooter id={prepaidCardId}/>} >
                    <PrepaidCardInfo cardId={prepaidCardId} />
                    <PrepaidCardAmount initialAmount={amount}/>
                    <PrepaidCardChargeMethod/>
                    <Divider/>
                    <PrepaidCardNotes/>
                </CtaLayout>
            </PrepaidProvider>
        </AppScreen>
    );
};

export default PrepaidCardChargeActivity;
